<template>
  <div class="tracking-page">
    <!-- 公告栏 -->
    <!-- <div v-if="showAnnounce" class="announce-bar">
      <div class="announce-content">
        <span class="announce-icon text-primary">ℹ️</span>
        <span class="announce-text">{{ t('announceText') }}</span>
        <a href="javascript:void(0)" class="announce-link text-primary"
          >{{ t('announceDetail') }}</a
        >
      </div>
      <button
        class="announce-close"
        @click="showAnnounce = false"
      >
        <span>✕</span>
      </button>
    </div> -->

    <!-- 头部 -->
    <header class="tracking-header">
      <div class="tracking-header__inner page-container">
        <a
          href="/"
          class="tracking-logo-link text-primary"
        >
          <div class="logo">
            <img src="../images/logo.png" width="188" />
          </div>
        </a>
        <div class="tracking-header__actions">
          <button
            type="button"
            class="mobile-search-button"
            :aria-label="t('openTrackingPanel')"
            :title="t('openTrackingPanel')"
            @click="toggleTrackingDrawer"
          >
            <i class="iconfont icon-parcel-02-search"></i>
          </button>
          <div class="language-switcher" @click.stop>
            <button
              type="button"
              class="language-switcher__trigger"
              @click.stop="toggleLanguageDropdown"
            >
              <span>🌐</span> {{ currentLanguageLabel }}
              <span class="language-switcher__arrow">▾</span>
            </button>
            <div
              v-if="isLangDropdownOpen"
              class="language-switcher__menu"
            >
              <button
                type="button"
                class="language-switcher__option"
                :class="currentLang === 'en' ? 'text-primary' : 'text-gray-700'"
                @click.stop="changeLanguage('en')"
              >
                {{ t('langEnglish') }}
              </button>
              <button
                type="button"
                class="language-switcher__option"
                :class="currentLang === 'zh' ? 'text-primary' : 'text-gray-700'"
                @click.stop="changeLanguage('zh')"
              >
                {{ t('langChinese') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>

    <!-- 状态标签栏 -->
    <div class="tracking-tabs-bar">
      <div class="tracking-tabs-bar__inner page-container">
        <div
          id="statusTabs"
          class="tracking-tabs scrollbar-hide"
        >
          <button
            v-for="tab in statusTabs"
            :key="tab.key"
            class="tab-item"
            :class="tab.active ? 'tab-item--active' : 'tab-item--inactive'"
            @click="setActiveTab(tab.key)"
          >
            <span :class="getStatusTextColor(tab.key)" v-html="tab.icon"></span>
            <span :class="getStatusTextColor(tab.key)">
              {{ tab.label
              }}<span class="tab-item__count">({{ tab.count }})</span>
            </span>
          </button>
        </div>
        <div class="tracking-tabs-actions">
          <button
            type="button"
            class="icon-action-button"
            :aria-label="t('copyAllShipments')"
            :title="t('copyAllShipments')"
            :disabled="copying || !shipments.length"
            @click="copyAllShipments"
          >
            <span>
              <i class="iconfont icon-copy-document"></i>
            </span>
          </button>
          <!-- <span class="sr-only" aria-live="polite">{{ copyMessage }}</span> -->
          <button
            type="button"
            class="icon-action-button"
            :aria-label="allShipmentsExpanded ? t('collapseAll') : t('expandAll')"
            :title="allShipmentsExpanded ? t('collapseAll') : t('expandAll')"
            :disabled="!shipments.length"
            @click="toggleAllShipments"
          >
            <span class="expand-toggle-icons">
              <i
                class="iconfont expand-toggle-icon"
                :class="allShipmentsExpanded ? 'icon-up-and-down-arrow expand-toggle-icon--expanded' : 'icon-zhedie expand-toggle-icon--collapsed'"
              ></i>
              <i
                v-if="!allShipmentsExpanded"
                class="iconfont icon-zhedie expand-toggle-icon expand-toggle-icon--collapsed expand-toggle-icon--mirror"
              ></i>
            </span>
          </button>
        </div>
      </div>
    </div>

    <!-- 主体 -->
    <div
      v-if="isMobileDrawerOpen"
      class="tracking-drawer-overlay"
      @click="closeTrackingDrawer"
    ></div>

    <main class="tracking-main page-container">
      <div class="tracking-layout">
        <!-- 左侧主内容 -->
        <section ref="trackingContentPanel" class="tracking-content-panel">
          <!-- 加载状态 -->
          <div v-if="loading" class="tracking-state">
            <div class="tracking-state__content">
              <div class="tracking-state__icon">⏳</div>
              <p class="text-gray-500">{{ t('loading') }}</p>
            </div>
          </div>

          <!-- 无数据状态 -->
          <div
            v-else-if="!currentShipment"
            class="tracking-state"
          >
            <div class="tracking-state__content">
              <div class="tracking-state__icon">📭</div>
              <p class="text-gray-500">{{ t('empty') }}</p>
            </div>
          </div>

          <!-- 数据展示 -->
          <template v-else>
            <div
              v-for="shipment in visibleShipments"
              :key="getShipmentNumber(shipment)"
              class="shipment-card"
              :class="currentShipment === shipment ? 'shipment-card--active' : ''"
            >
              <div
                class="shipment-card__summary"
                @click.stop="toggleShipment(shipment)"
              >
                <div
                  class="shipment-card__status"
                  :class="getStatusColor(shipment.LatestLogisticsStatus)"
                >
                  <span class="visible-icon" v-html="getStatusIcon(shipment.LatestLogisticsStatus)"></span>
                </div>
                <div class="shipment-card__main">
                  <div class="shipment-card__number-row">
                    <span
                      id="trackingNumber"
                      class="shipment-card__number"
                      >{{ getShipmentDisplayNumber(shipment) }}</span
                    >
                    <button
                      type="button"
                      class="shipment-card__copy"
                      :aria-label="t('copyShipmentNumber', { number: getShipmentNumber(shipment) })"
                      :title="t('copyShipmentInfo')"
                      :disabled="copying"
                      @click.stop="copyShipment(shipment)"
                    >
                      <span>
                        <i class="iconfont icon-copy-document"></i>
                      </span>
                    </button>
                  </div>
                  <div class="shipment-card__status-row text-gray-500">
                    <span  >
                      {{ getStatusDisplay(shipment.LatestLogisticsStatus, shipment) }}
                    </span>
                  </div>
                  <!-- <div class="mt-1 flex items-center gap-2 text-xs text-gray-500">
                  <span>承运商: {{ shipment.ShippingServiceName || '未知' }}</span>
                  <span v-if="shipment.SignDay">· 签收后 {{ shipment.SignDay }} 天</span>
                </div> -->
                </div>

                <div class="shipment-card__route route-brief" v-show="shipment.TrackingLogs">
                  <div class="route-brief__point">
                    <!-- <p>发件</p> -->
                    <p class="route-brief__country">CN</p>
                  </div>
                  <span class="route-brief__arrow">
                    <i class="iconfont icon-single-arrow"></i>
                  </span>
                  <div class="route-brief__point">
                    <!-- <p>收件</p> -->
                    <p class="route-brief__country">
                      {{ shipment.ReceiverCountryCode || "" }}
                    </p>
                  </div>
                </div>

                <div class="shipment-card__aside">
                  <div class="shipment-card__latest latest-info">
                    <p
                      id="latestTime"
                      class="latest-info__time"
                    >
                      {{ formatTime(shipment.TriggerTime) }}
                    </p>
                    <p
                      id="latestText"
                      class="latest-info__text"
                    >
                      {{ getLatestTrackingText(shipment) }}
                    </p>
                  </div>
                  <button
                    class="shipment-card__toggle"
                    type="button"
                    :aria-expanded="isShipmentExpanded(shipment)"
                    @click.stop="toggleShipment(shipment)"
                  >
                    <span class="shipment-card__toggle-icon" v-show="shipment.TrackingLogs && shipment.TrackingLogs.length > 0">{{ isShipmentExpanded(shipment) ? '▴' : '▾' }}</span>
                    <span class="shipment-card__toggle-icon_no" v-show="!shipment.TrackingLogs || shipment.TrackingLogs.length === 0"></span>
                  </button>
                </div>
              </div>

              <transition name="shipment-detail">
                <div
                  v-if="isShipmentExpanded(shipment)"
                  class="shipment-detail"
                >
              <!-- <div
                class="mb-3 flex flex-wrap items-center gap-2 border-b border-gray-100 pb-3 text-xs"
              >
                <span
                  class="flex h-6 w-6 items-center justify-center rounded bg-[#0f5fc4] text-[8px] font-bold text-white"
                  >XYY</span
                >
                <span class="font-semibold text-gray-900">XYY - 国际专线</span>
                <span class="text-gray-400"
                  >同步于:
                  <span id="syncTime">{{ formatSyncTime() }}</span></span
                >
                <a
                  v-if="shipment.ShippingServiceUrl"
                  :href="shipment.ShippingServiceUrl"
                  target="_blank"
                  class="ml-1 text-primary hover:underline"
                  >查看承运商</a
                >
              </div> -->

              <div class="timeline">
                <ul id="eventList" class="timeline__list">
                  <span class="timeline__line"></span>
                  <li
                    v-for="(evt, idx) in getTrackingLogs(shipment)"
                    :key="idx"
                    class="timeline__item"
                  >
                    <span
                      class="timeline__dot"
                      :class="[
                        idx === 0
                          ? `timeline__dot--active ${getStatusColor(shipment.LatestLogisticsStatus)}`
                          : 'timeline__dot--inactive'
                      ]"
                    >
                    </span>
                    <div class="timeline__content">
                      <span
                        class="timeline__time"
                        :class="idx === 0 ? 'timeline__time--active' : 'timeline__time--inactive'"
                        >{{ formatTime(evt.TriggerTime) }}</span
                      >
                      <span
                        class="timeline__text"
                        :class="idx === 0 ? 'timeline__text--active' : 'timeline__text--inactive'"
                        >{{ evt.StatusString }}</span
                      >
                    </div>
                  </li>
                </ul>
              </div>
                </div>
              </transition>
            </div>
          </template>
        </section>

        <!-- 右侧边栏 -->
        <aside
          class="tracking-sidebar"
          :class="{ 'tracking-sidebar--drawer-open': isMobileDrawerOpen }"
        >
          <div class="tracking-sidebar__panel">
            <div
              v-if="trackingRows.length"
              class="tracking-input-list"
            >
              <div
                v-for="(shipment, index) in trackingRows"
                :key="`draft-${index}`"
                class="tracking-input-row"
              >
                <span class="tracking-input-row__index"
                  >{{ index + 1 }}.</span
                >
                <input
                  class="tracking-input-row__field"
                  :value="getShipmentNumber(shipment)"
                  :placeholder="index === 0 ? t('inputPlaceholderFirst') : t('inputPlaceholderNext')"
                  :aria-label="t('trackingNumberLabel', { index: index + 1 })"
                  @input="
                    updateShipmentNumber(shipment, $event.target.value, index)
                  "
                  @keydown.enter.prevent="addTrackingRow(index)"
                  @keydown.backspace="handleTrackingInputBackspace($event, index)"
                  @paste="handleTrackingNumberPaste($event, index)"
                />
                <button
                  v-if="trackingRows.length > 0"
                  class="tracking-input-row__remove"
                  type="button"
                  :aria-label="t('removeTrackingNumber', { index: index + 1 })"
                  @click="removeTrackingRow(index)"
                >
                  <span>✕</span>
                </button>
              </div>
            </div>
            <div class="tracking-sidebar__toolbar">
              <button
                class="sidebar-action-button"
                type="button"
                :disabled="copying || !trackingNumberCount"
                @click="copyAllTrackingNumbers"
              >
                <span>
                  <i class="iconfont icon-copy-document"></i>
                </span>
              </button>
              <button
                class="sidebar-action-button"
                type="button"
                :disabled="!trackingNumberCount"
                :aria-label="t('clearAllTrackingNumbers')"
                :title="t('clearAllTrackingNumbers')"
                @click="clearAllTrackingNumbers"
              >
                <span>
                  <i class="iconfont icon-delete"></i>
                </span>
              </button>
            </div>
            <div class="tracking-sidebar__submit">
              <button
                class="query-button"
                type="button"
                :disabled="loading || !trackingNumberCount"
                @click="refreshData"
              >
                <i class="iconfont icon-parcel-02-search"></i>
                {{ t('query') }} ({{ trackingNumberCount }})
              </button>
            </div>
          </div>
        </aside>
      </div>
    </main>
    <div class="tracking-footer-placeholder">
      <div
        class="tracking-footer-card"
      >
        <div class="tracking-footer-layout">
          <section class="tracking-footer-hero tracking-footer-hero--media">
            <a
              class="tracking-footer-media"
              href="https://drocen.com"
              target="_blank"
              rel="noopener noreferrer"
              :aria-label="t('adView')"
              :title="t('adView')"
            >
              <img
                :class="['tracking-footer-image', currentLang.indexOf('zh') !== -1 ? 'tracking-footer-image--zh' : '']"
                :src="footerImageSrc"
                alt="dropshipping"
              >
            </a>
          </section>
          <section :class="['tracking-footer-support', currentLang.indexOf('zh') !== -1 ? 'tracking-footer-support--zh' : '']">
            <div class="tracking-footer-support__header">
              <h3 class="tracking-footer-support__title">{{ t('footerHelpTitle') }}</h3>
              <p class="tracking-footer-support__subtitle">{{ t('footerHelpSubtitle') }}</p>
            </div>
            <div class="tracking-footer-support__grid">
              <a
                v-for="support in footerSupportChannels"
                :key="support.key"
                class="tracking-footer-support-card"
                :href="support.href"
                :target="support.target || null"
                :rel="support.rel || null"
                :aria-label="support.title"
                :title="support.title"
                @click="handleFooterSupportClick(support, $event)"
              >
                <span class="tracking-footer-support-card__icon" aria-hidden="true">
                  <i
                    class="iconfont"
                    :class="support.icon === 'support' ? 'icon-kefu' : support.icon === 'email' ? 'icon-email' : 'icon-xiaoxi'"
                  ></i>
                </span>
                <strong class="tracking-footer-support-card__title">{{ support.title }}</strong>
                <span class="tracking-footer-support-card__arrow" aria-hidden="true">→</span>
              </a>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Message from '../utils/message'
const STATUS_LABELS = {
  en: {
    Delivered: 'Delivered',
    Transit: 'Transit',
    InfoReceived: 'Info Received',
    Pickup: 'Pickup',
    Delivery: 'Out for Delivery',
    Failed: 'Failed',
    Exception: 'Exception',
    NotFound: 'Not Found'
  },
  zh: {
    Delivered: '已签收',
    Transit: '运输中',
    InfoReceived: '已收到信息',
    Pickup: '到达待取',
    Delivery: '派送中',
    Failed: '派送失败',
    Exception: '异常',
    NotFound: '暂无结果'
  }
}

const TAB_LABELS = {
  en: {
    all: 'All',
    Transit: 'Transit',
    Pickup: 'Pickup',
    Delivered: 'Delivered',
    UnDelivered: 'UnDelivered',
    Exception: 'Exception',
    NotFound: 'NotFound'
  },
  zh: {
    all: '全部',
    Transit: '运输中',
    Pickup: '到达待取',
    Delivered: '已签收',
    UnDelivered: '未妥投',
    Exception: '异常',
    NotFound: '无结果'
  }
}

const MESSAGE_MAP = {
  en: {
    langEnglish: 'English',
    langChinese: '中文',
    announceText: '📦 USPS deliveries may be delayed in some areas due to weather conditions',
    announceDetail: 'Details >',
    copyAllShipments: 'Copy all tracking information',
    collapseAll: 'Collapse all',
    expandAll: 'Expand all',
    loading: 'Loading...',
    empty: 'No tracking information',
    copyShipmentNumber: 'Copy tracking number {number}',
    copyShipmentInfo: 'Copy tracking information',
    inputPlaceholderFirst: 'Enter tracking number',
    inputPlaceholderNext: 'Continue entering tracking number',
    trackingNumberLabel: 'Tracking number {index}',
    removeTrackingNumber: 'Remove tracking number {index}',
    clearAllTrackingNumbers: 'Clear all tracking numbers',
    query: 'Track',
    openTrackingPanel: 'Open tracking panel',
    copied: 'Tracking information copied',
    copyFailed: 'Copy failed, please try again',
    noTrackingInfo: 'No tracking information',
    signDaySuffix: ' days',
    exportTrackingNumber: 'Tracking Number',
    exportPackageStatus: 'Package Status',
    footerBrandTagline: 'Your Trusted Dropshipping Partner',
    footerHeroTitle: 'Professional. Responsive. Reliable Dropshipping.',
    footerHeroSubtitle: 'Make your business easier, more profitable.',
    footerFeatureQualityTitle: 'Premium Quality',
    footerFeatureQualitySubtitle: 'Professional team support',
    footerFeatureStabilityTitle: 'Reliable & Stable',
    footerFeatureStabilitySubtitle: 'Systemized process, stable delivery',
    footerFeaturePriceTitle: 'Competitive Price',
    footerFeaturePriceSubtitle: 'Cost-effective solutions, stronger margin',
    footerHelpTitle: 'Need Help?',
    footerHelpSubtitle: 'If you need to show your business here, please contact us',
    footerSupportContact: 'Contact Support',
    footerSupportEmail: 'Email Us',
    footerSupportChat: 'Live Chat',
    copiedPhone: 'Phone number copied: {phone}'
  },
  zh: {
    langEnglish: 'English',
    langChinese: '中文',
    announceText: '📦 USPS 物流可能受天气影响，部分区域派送延迟',
    announceDetail: '详情 >',
    copyAllShipments: '复制全部物流信息',
    collapseAll: '全部折叠数据',
    expandAll: '展开全部数据显示',
    loading: '加载中...',
    empty: '暂无物流信息',
    copyShipmentNumber: '复制单号 {number}',
    copyShipmentInfo: '复制物流信息',
    inputPlaceholderFirst: '请输入单号',
    inputPlaceholderNext: '继续输入单号',
    trackingNumberLabel: '单号 {index}',
    removeTrackingNumber: '删除单号 {index}',
    clearAllTrackingNumbers: '清除所有单号',
    query: '查询',
    openTrackingPanel: '打开查询面板',
    copied: '物流信息已复制',
    copyFailed: '复制失败，请重试',
    noTrackingInfo: '暂无物流信息',
    signDaySuffix: ' 天',
    exportTrackingNumber: '单号',
    exportPackageStatus: '包裹状态',
    footerBrandTagline: '值得信赖的 Dropshipping 合作伙伴',
    footerHeroTitle: '专业响应，稳定履约，让 Dropshipping 更可靠。',
    footerHeroSubtitle: '让你的业务更省心，也更有利润空间。',
    footerFeatureQualityTitle: '高品质服务',
    footerFeatureQualitySubtitle: '专业团队全程支持',
    footerFeatureStabilityTitle: '稳定履约',
    footerFeatureStabilitySubtitle: '流程系统化，交付更稳定',
    footerFeaturePriceTitle: '更优价格',
    footerFeaturePriceSubtitle: '高性价比方案，提升利润空间',
    footerHelpTitle: '需要帮助?',
    footerHelpSubtitle: '如果在这也需要展示您的业务，请联系我们',
    footerSupportContact: '联系支持',
    footerSupportEmail: '邮件咨询',
    footerSupportChat: '在线沟通',
    copiedPhone: '电话已复制：{phone}'
  }
}

export default {
  name: 'TrackingApp',
  data () {
    return {
      showAnnounce: true,
      transOn: false,
      loading: false,
      shipments: [],
      currentShipment: {},
      expandedShipments: [],
      copying: false,
      copyMessage: '',
      trackingRows: [],
      currentLang: 'en',
      isLangDropdownOpen: false,
      isMobileDrawerOpen: false,
      statusTabs: [
        {
          key: 'all',
          label: 'All',
          count: 0,
          active: true,
          icon: '<i class="iconfont icon-all"></i>'
        },
        {
          key: 'Transit',
          label: 'Transit',
          count: 0,
          icon: '<i class="iconfont icon-plane-departure-solid"></i  >'
        },
        {
          key: 'Pickup',
          label: 'Pickup',
          count: 0,
          icon: '<i class="iconfont icon-pick-up-16"></i>'
        },
        {
          key: 'Delivered',
          label: 'Delivered',
          count: 0,
          icon: '<i class="iconfont icon-package-delivered"></i>'
        },
        {
          key: 'UnDelivered',
          label: 'UnDelivered',
          count: 0,
          icon: '<i class="iconfont icon-Undelivered"></i>'
        },
        {
          key: 'Exception',
          label: 'Exception',
          count: 0,
          icon: '<i class="iconfont icon-yichang"></i>'
        },
        {
          key: 'NotFound',
          label: 'NotFound',
          count: 0,
          icon:
            '<i class="iconfont icon-status_notfound"></i>'
        }
      ],
      trackingNumbers: [],
      wheelScrollPending: false,
      lastWheelTime: 0,
      wheelScrollFrameId: null,
      token: '29301AD4500BB72059677F1EF6198CFD',
      trackingUrl: 'https://customerservice.xingyunyi.cn/api/Order/GetTracking'
    }
  },
  computed: {
    visibleShipments () {
      const activeTab = this.statusTabs.find(tab => tab.active)
      const uniqueShipments = this.shipments.filter((shipment, index, list) => {
        const number = this.getShipmentNumber(shipment)
        if (!number) {
          return true
        }
        return index === list.findIndex(item => this.getShipmentNumber(item) === number)
      })
      if (!activeTab || activeTab.key === 'all') {
        return uniqueShipments
      }
      return uniqueShipments.filter(
        shipment => shipment.LatestLogisticsStatus === activeTab.key
      )
    },
    trackingNumberCount () {
      return this.trackingRows
        .map(row => this.getShipmentNumber(row))
        .filter(Boolean)
        .length
    },
    sortedTrackingLogs () {
      if (!this.currentShipment || !this.currentShipment.TrackingLogs) {
        return []
      }
      // 按时间降序排列（最新的在前）
      return [...this.currentShipment.TrackingLogs].sort((a, b) => {
        return new Date(b.TriggerTime) - new Date(a.TriggerTime)
      })
    },
    allShipmentsExpanded () {
      return this.shipments.length > 0 && this.expandedShipments.length === this.shipments.length
    },
    currentMessages () {
      return MESSAGE_MAP[this.currentLang] || MESSAGE_MAP.en
    },
    currentLanguageLabel () {
      return this.currentLang === 'zh'
        ? this.currentMessages.langChinese
        : this.currentMessages.langEnglish
    },
    footerImageSrc () {
      return this.currentLang.indexOf('zh') !== -1
        ? require('../images/dropshipping_cn.jpg')
        : require('../images/dropshipping_en.jpg')
    },
    footerHighlights () {
      return [
        {
          key: 'quality',
          icon: 'quality',
          title: this.t('footerFeatureQualityTitle'),
          subtitle: this.t('footerFeatureQualitySubtitle')
        },
        {
          key: 'stability',
          icon: 'stability',
          title: this.t('footerFeatureStabilityTitle'),
          subtitle: this.t('footerFeatureStabilitySubtitle')
        },
        {
          key: 'price',
          icon: 'price',
          title: this.t('footerFeaturePriceTitle'),
          subtitle: this.t('footerFeaturePriceSubtitle')
        }
      ]
    },
    footerSupportChannels () {
      return [
        {
          key: 'support',
          icon: 'support',
          title: this.t('footerSupportContact'),
          href: 'tel:15011778820',
          value: '15011778820',
          action: 'copyPhoneOnDesktop'
        },
        {
          key: 'email',
          icon: 'email',
          title: this.t('footerSupportEmail'),
          href: 'mailto:juan@xingyunyi.com'
        },
        {
          key: 'chat',
          icon: 'chat',
          title: this.t('footerSupportChat'),
          href: '/',
          target: '_blank',
          rel: 'noopener noreferrer'
        }
      ]
    }
  },
  mounted () {
    this.currentLang = this.getInitialLanguage()
    this.applyTabLabels()
    const initialTrackingNumbers = this.getInitialTrackingNumbers()
    if (initialTrackingNumbers.length) {
      this.trackingNumbers = initialTrackingNumbers
      this.syncTrackingRowsWithNumbers(initialTrackingNumbers)
    } else {
      this.trackingRows = this.shipments.length
        ? this.shipments.map(shipment => ({
          ...shipment,
          InputTrackingNumber: shipment.InputTrackingNumber || ''
        }))
        : [{ InputTrackingNumber: '' }]
    }
    this.fetchTrackingData()
    document.addEventListener('click', this.handleDocumentClick)
    window.addEventListener('wheel', this.handleGlobalWheel, { passive: false })
  },
  beforeDestroy () {
    document.removeEventListener('click', this.handleDocumentClick)
    window.removeEventListener('wheel', this.handleGlobalWheel)
    if (this.wheelScrollFrameId !== null) {
      cancelAnimationFrame(this.wheelScrollFrameId)
      this.wheelScrollFrameId = null
      this.wheelScrollPending = false
    }
  },
  methods: {
    t (key, params = {}) {
      const message = this.currentMessages[key] || key
      return Object.keys(params).reduce((text, paramKey) => {
        return text.replace(`{${paramKey}}`, params[paramKey])
      }, message)
    },
    getInitialLanguage () {
      const path = (this.$route && this.$route.path) || window.location.pathname || ''
      return path.indexOf('/cn') !== -1 ? 'zh' : 'en'
    },
    getInitialTrackingNumbers () {
      const routeQuery = (this.$route && this.$route.query) || {}
      const routeNums = routeQuery.nums || routeQuery.num || routeQuery.trackingNumber || routeQuery.trackingNo || ''
      const searchParams = typeof window !== 'undefined' && window.location.search
        ? new URLSearchParams(window.location.search)
        : null
      const searchNums = !routeNums && searchParams
        ? (
          searchParams.get('nums') ||
          searchParams.get('num') ||

          searchParams.get('trackingNumber') ||
          searchParams.get('trackingNo') ||
          ''
        )
        : routeNums
      const rawValue = Array.isArray(searchNums) ? searchNums.join(',') : (searchNums || '')
      return rawValue
        .split(/[，,\s]+/)
        .map(item => item.trim())
        .filter(Boolean)
    },
    applyTabLabels () {
      this.statusTabs = this.statusTabs.map(tab => ({
        ...tab,
        label: (TAB_LABELS[this.currentLang] && TAB_LABELS[this.currentLang][tab.key]) || tab.label
      }))
    },
    areQueriesEqual (queryA = {}, queryB = {}) {
      const keysA = Object.keys(queryA).sort()
      const keysB = Object.keys(queryB).sort()
      if (keysA.length !== keysB.length) {
        return false
      }
      return keysA.every((key, index) => {
        if (key !== keysB[index]) {
          return false
        }
        return String(queryA[key]) === String(queryB[key])
      })
    },
    replaceRouteSafely (location) {
      if (!this.$router) {
        return Promise.resolve()
      }
      return this.$router.replace(location).catch(error => {
        if (error && error.name === 'NavigationDuplicated') {
          return null
        }
        throw error
      })
    },
    toggleLanguageDropdown () {
      this.isLangDropdownOpen = !this.isLangDropdownOpen
    },
    toggleTrackingDrawer () {
      this.isMobileDrawerOpen = !this.isMobileDrawerOpen
    },
    closeTrackingDrawer () {
      this.isMobileDrawerOpen = false
    },
    handleDocumentClick () {
      this.isLangDropdownOpen = false
    },
    changeLanguage (lang) {
      if (this.currentLang === lang) {
        this.isLangDropdownOpen = false
        return
      }
      this.currentLang = lang
      this.applyTabLabels()
      this.isLangDropdownOpen = false
      const currentPath = (this.$route && this.$route.path) || window.location.pathname || ''
      const currentQuery = (this.$route && this.$route.query) || {}
      const targetPath = lang === 'zh'
        ? currentPath.indexOf('/cn') === 0
          ? currentPath
          : `/cn${currentPath}`
        : currentPath.replace(/^\/cn/, '') || '/tracking'
      if (this.$route && this.$route.path !== targetPath) {
        this.replaceRouteSafely({ path: targetPath, query: currentQuery })
      }
    },
    getTrackingContentPanel () {
      const panel = this.$refs.trackingContentPanel
      return panel instanceof HTMLElement ? panel : null
    },
    isScrollableElement (element) {
      if (!(element instanceof HTMLElement)) {
        return false
      }
      // 快速判断：检查是否可滚动
      const overflowY = window.getComputedStyle(element).overflowY
      return /(auto|scroll|overlay)/.test(overflowY) && element.scrollHeight > element.clientHeight
    },
    canElementScroll (element, deltaY) {
      if (!this.isScrollableElement(element) || !deltaY) {
        return false
      }
      const threshold = 2 // 小阈值避免边界抖动
      if (deltaY > 0) {
        return element.scrollTop + element.clientHeight < element.scrollHeight - threshold
      }
      return element.scrollTop > threshold
    },
    findScrollableAncestor (target, stopElement) {
      let current = target instanceof HTMLElement ? target : null
      while (current && current !== stopElement && current !== document.body) {
        if (this.isScrollableElement(current)) {
          return current
        }
        current = current.parentElement
      }
      return null
    },
    handleGlobalWheel (event) {
      if (event.defaultPrevented || !event.deltaY) {
        return
      }
      const panel = this.getTrackingContentPanel()
      if (!panel) {
        return
      }
      const target = event.target instanceof HTMLElement ? event.target : null

      // 面板内使用原生滚动，避免全局事件重复接管滚动位置
      if (target && panel.contains(target)) {
        return
      }

      const nestedScrollable = this.findScrollableAncestor(target, panel)
      // 如果事件在嵌套滚动容器内，且该容器可滚动，则不干预
      if (nestedScrollable && this.canElementScroll(nestedScrollable, event.deltaY)) {
        return
      }

      // 检查面板是否可滚动
      if (!this.canElementScroll(panel, event.deltaY)) {
        return
      }
      // 阻止默认行为，防止页面滚动
      event.preventDefault()
      event.stopPropagation()
      // 直接使用 scrollBy 不带 smooth，实现即时响应
      // 使用 requestAnimationFrame 优化渲染性能
      if (!this.wheelScrollPending) {
        this.wheelScrollPending = true
        this.wheelScrollFrameId = requestAnimationFrame(() => {
          // 累积滚动量，一次性应用，减少重绘次数
          const deltaY = event.deltaY * 2
          panel.scrollTop += deltaY
          this.wheelScrollFrameId = null
          this.wheelScrollPending = false
        })
      } else {
        // 如果已有待处理的滚动，累积 deltaY
        panel.scrollTop += (event.deltaY * 2)
      }
    },
    normalizeTrackingNumber (value) {
      return (value || '').toString().trim().toUpperCase()
    },
    getShipmentMatchKey (shipment) {
      return this.normalizeTrackingNumber(
        shipment && (shipment.InputTrackingNumber)
      )
    },
    buildTrackingRowsFromNumbers (numbers = []) {
      const rows = numbers.map(number => ({ InputTrackingNumber: number }))
      return rows.length ? [...rows, { InputTrackingNumber: '' }] : [{ InputTrackingNumber: '' }]
    },
    syncTrackingRowsWithNumbers (numbers = []) {
      this.trackingRows = this.buildTrackingRowsFromNumbers(numbers)
    },
    mergeShipmentsByTrackingNumbers (shipments = [], numbers = []) {
      const shipmentMap = shipments.reduce((map, shipment) => {
        const key = this.getShipmentMatchKey(shipment)
        if (key && !map[key]) {
          map[key] = shipment
        }
        return map
      }, {})
      const orderedShipments = numbers.map(number => {
        const key = this.normalizeTrackingNumber(number)
        return shipmentMap[key] || {
          InputTrackingNumber: number,
          TransferNumber: number,
          LatestLogisticsStatus: 'NotFound',
          TrackingLogs: []
        }
      })
      const extraShipments = shipments.filter(shipment => {
        const key = this.getShipmentMatchKey(shipment)
        return key && !numbers.some(number => this.normalizeTrackingNumber(number) === key)
      })
      return [...orderedShipments, ...extraShipments]
    },
    async fetchTrackingData () {
      if (!this.trackingNumbers.length) {
        this.shipments = []
        this.syncTrackingRowsWithNumbers([])
        this.currentShipment = null
        this.expandedShipments = []
        this.updateStatusTabs()
        return
      }
      this.loading = true
      try {
        const response = await fetch(this.trackingUrl, {
          headers: {
            accept: 'application/json, text/plain, */*',
            'accept-language': 'zh,en;q=0.9,zh-CN;q=0.8',
            authorization: 'token ' + this.token,
            'cache-control': 'no-cache',
            'content-type': 'application/json',
            pragma: 'no-cache'
          },
          body: JSON.stringify({
            Numbers: this.trackingNumbers
          }),
          method: 'POST'
        })

        const result = await response.json()

        if (result.code === 200 && result.success && result.data) {
          this.shipments = result.data
          this.syncTrackingRowsWithNumbers(this.trackingNumbers)
          if (this.shipments.length == 1) { this.expandedShipments = [...this.shipments] } else { this.expandedShipments = [] }
          // 默认显示第一个有完整信息的包裹
          this.currentShipment =
            this.shipments.find(
              s => s.TrackingLogs && s.TrackingLogs.length > 0
            ) ||
            this.shipments[0] ||
            null
          this.updateStatusTabs()
        } else {
          Message.error('API error!')
          this.shipments = []
          this.syncTrackingRowsWithNumbers(this.trackingNumbers)
          this.updateStatusTabs()
        }
      } catch (error) {
        console.error('获取物流数据失败:', error)
        Message.error(error)
        this.shipments = []
        this.syncTrackingRowsWithNumbers(this.trackingNumbers)
        this.currentShipment = null
        this.expandedShipments = []
        this.updateStatusTabs()
      } finally {
        this.loading = false
      }
    },
    resetStatusTabs () {
      this.statusTabs = this.statusTabs.map(tab => ({
        ...tab,
        active: tab.key === 'all',
        count: 0,
        label: (TAB_LABELS[this.currentLang] && TAB_LABELS[this.currentLang][tab.key]) || tab.label
      }))
    },

    refreshData () {
      if (this.loading) {
        return
      }
      this.trackingNumbers = [...new Set(
        this.trackingRows
          .map(row => this.getShipmentNumber(row))
          .filter(Boolean)
      )]
      this.syncTrackingRowsWithNumbers(this.trackingNumbers)
      this.resetStatusTabs()
      this.currentShipment = null
      this.expandedShipments = []
      const currentQuery = (this.$route && this.$route.query) || {}
      const nextQuery = { ...currentQuery }
      if (this.trackingNumbers.length) {
        nextQuery.nums = this.trackingNumbers.join(',')
      } else {
        delete nextQuery.nums
      }
      if (!this.$route || !this.areQueriesEqual(currentQuery, nextQuery)) {
        this.replaceRouteSafely({ query: nextQuery })
      }
      this.fetchTrackingData()
      this.closeTrackingDrawer()
    },
    getShipmentNumber (shipment) {
      return shipment
        ? shipment.InputTrackingNumber : ''
    },
    // 展示用单号：当承运商实际单号(TrackingNumber)与用户输入单号(InputTrackingNumber)不一致时，
    // 显示为 InputTrackingNumber(TrackingNumber)，否则仅显示输入单号
    getShipmentDisplayNumber (shipment) {
      const input = shipment && shipment.InputTrackingNumber ? String(shipment.InputTrackingNumber) : ''
      const tracking = shipment && shipment.TrackingNumber ? String(shipment.TrackingNumber) : ''
      if (tracking && input && tracking !== input) {
        return `${input}(${tracking})`
      }
      return input
    },
    // 在 methods 中添加以下方法
    focusNextInput (index) {
      // 等待 DOM 更新后聚焦到下一个输入框
      this.$nextTick(() => {
        const rows = this.$el.querySelectorAll('.tracking-input-row')
        const nextRow = rows[index + 1]
        if (nextRow) {
          const input = nextRow.querySelector('.tracking-input-row__field')
          if (input) {
            input.focus()
            // 选中输入框中的文本，方便直接输入新单号
            input.select()
          }
        }
      })
    },
    focusPreviousInput (index) {
      this.$nextTick(() => {
        const rows = this.$el.querySelectorAll('.tracking-input-row')
        const previousRow = rows[Math.max(0, index - 1)]
        const input = previousRow && previousRow.querySelector('.tracking-input-row__field')
        if (input) {
          input.focus()
          input.select()
        }
      })
    },
    focusLastInput () {
      this.$nextTick(() => {
        const rows = this.$el.querySelectorAll('.tracking-input-row')
        const lastRow = rows[rows.length - 1]
        const input = lastRow && lastRow.querySelector('.tracking-input-row__field')
        if (input) {
          input.focus()
          input.select()
        }
      })
    },
    // 修改 addTrackingRow 方法
    addTrackingRow (index) {
      const isLastRow = index === this.trackingRows.length - 1
      const currentValue = this.getShipmentNumber(this.trackingRows[index])

      // 如果当前输入框为空，不添加新行，聚焦到下一个输入框
      if (!currentValue) {
        this.focusNextInput(index)
        return
      }

      // 检查是否已存在相同单号（去重）
      const exists = this.trackingRows.some((row, i) =>
        i !== index && this.getShipmentNumber(row) === currentValue
      )

      if (exists) {
        // 如果单号已存在，清空当前输入框并聚焦到下一个
        this.trackingRows[index].InputTrackingNumber = ''
        this.focusNextInput(index)
        return
      }

      if (isLastRow) {
        // 在最后一行添加新行
        this.trackingRows.push({ InputTrackingNumber: '' })
        // 等待 DOM 更新后聚焦到新添加的行
        this.$nextTick(() => {
          const rows = this.$el.querySelectorAll('.tracking-input-row')
          const newRow = rows[rows.length - 1]
          if (newRow) {
            const input = newRow.querySelector('.tracking-input-row__field')
            if (input) {
              input.focus()
            }
          }
        })
      } else {
        // 在中间行添加新行
        this.trackingRows.splice(index + 1, 0, { InputTrackingNumber: '' })
        this.focusNextInput(index)
      }
    },
    removeTrackingRow (index) {
      if (this.trackingRows.length <= 1) {
        this.trackingRows = [{ InputTrackingNumber: '' }]
        return
      }
      // 只移除右侧输入列表中的单号，不影响主区域的物流数据。
      this.trackingRows.splice(index, 1)
    },
    handleTrackingInputBackspace (event, index) {
      const row = this.trackingRows[index]
      if (!row || this.getShipmentNumber(row)) {
        return
      }

      event.preventDefault()
      this.removeTrackingRow(index)
      this.focusPreviousInput(index)
    },
    clearAllTrackingNumbers () {
      this.syncTrackingRowsWithNumbers([])
      this.trackingNumbers = []
    },
    selectShipment (shipment) {
      this.currentShipment = shipment
    },
    toggleShipment (shipment) {
      if (!shipment.TrackingLogs || shipment.TrackingLogs.length === 0) return
      this.currentShipment = shipment
      const index = this.expandedShipments.indexOf(shipment)
      if (index === -1) {
        this.expandedShipments.push(shipment)
      } else {
        this.expandedShipments.splice(index, 1)
      }
    },
    toggleAllShipments () {
      if (!this.shipments.length) return
      this.expandedShipments = this.allShipmentsExpanded ? [] : [...this.shipments]
    },
    isShipmentExpanded (shipment) {
      return this.expandedShipments.indexOf(shipment) !== -1
    },
    updateShipmentNumber (shipment, value, index) {
      const number = value.trim()
      this.$set(shipment, 'InputTrackingNumber', number)

      // 实时检查是否与已有单号重复，并添加视觉提示
      if (typeof index === 'number') {
        const duplicate = number && this.trackingRows.some((row, i) =>
          i !== index && this.getShipmentNumber(row) === number
        )
        const rowElement = this.$el.querySelectorAll('.tracking-input-row')[index]
        if (rowElement) {
          rowElement.classList.toggle('has-duplicate', Boolean(duplicate))
        }
      }
    },
    extractTrackingNumbers (text) {
      // 优先匹配复制格式中的“单号： XXX / Tracking Number: XXX”行，兼容直接粘贴的纯单号列表
      const labelMatches = [...text.matchAll(/(?:单号|Tracking Number)[：:]\s*(\S+)/g)].map(
        match => match[1]
      )
      if (labelMatches.length) return [...new Set(labelMatches)]
      return [...new Set(
        text
          .split(/[\r\n]+/)
          .map(item => item.trim())
          .filter(Boolean)
      )]
    },
    handleTrackingNumberPaste (event, index) {
      const text = (event.clipboardData || window.clipboardData).getData('text')
      if (!text) return
      const numbers = this.extractTrackingNumbers(text)
      // console.info(text);
      if (numbers.length <= 0) return
      event.preventDefault()
      numbers.forEach((number, offset) => {
        const rowIndex = index + offset
        if (rowIndex < this.trackingRows.length) {
          this.updateShipmentNumber(this.trackingRows[rowIndex], number, rowIndex)
        } else {
          this.trackingRows.push({ InputTrackingNumber: number })
        }
      })
      const lastRow = this.trackingRows[this.trackingRows.length - 1]
      if (this.getShipmentNumber(lastRow)) {
        this.trackingRows.push({ InputTrackingNumber: '' })
      }
      this.focusLastInput()
    },
    removeShipment (index) {
      const removedShipment = this.visibleShipments[index]
      const sourceIndex = this.shipments.indexOf(removedShipment)
      this.shipments.splice(sourceIndex, 1)
      if (this.currentShipment === removedShipment) {
        this.currentShipment =
          this.visibleShipments[index] ||
          this.visibleShipments[index - 1] ||
          this.shipments[0] ||
          null
      }
      const expandedIndex = this.expandedShipments.indexOf(removedShipment)
      if (expandedIndex !== -1) {
        this.expandedShipments.splice(expandedIndex, 1)
      }
      this.updateStatusTabs()
    },
    updateStatusTabs () {
      this.statusTabs = this.statusTabs.map(tab => {
        const count =
          tab.key === 'all'
            ? this.shipments.length
            : this.shipments.filter(s => s.LatestLogisticsStatus === tab.key)
              .length
        return {
          ...tab,
          count,
          label: (TAB_LABELS[this.currentLang] && TAB_LABELS[this.currentLang][tab.key]) || tab.label
        }
      })
    },

    setActiveTab (key) {
      this.statusTabs = this.statusTabs.map(tab => ({
        ...tab,
        active: tab.key === key
      }))
      // 切换标签时筛选显示对应状态的包裹
      if (key === 'all') {
        this.currentShipment =
          this.shipments.find(
            s => s.TrackingLogs && s.TrackingLogs.length > 0
          ) ||
          this.shipments[0] ||
          null
      } else {
        const filtered = this.visibleShipments
        this.currentShipment =
          filtered.find(s => s.TrackingLogs && s.TrackingLogs.length > 0) ||
          filtered[0] ||
          null
      }
    },

    getStatusIcon (status) {
      const statusKey = {
        InfoReceived: 'Transit',
        Delivery: 'Transit',
        Failed: 'Exception'
      }[status] || status
      const tab = this.statusTabs.find(item => item.key === statusKey)
      return tab ? tab.icon : '<i class="iconfont icon-all"></i>'
    },

    getStatusColor (status) {
      const map = {
        Delivered: 'status-bg-success',
        Transit: 'status-bg-primary',
        InfoReceived: 'status-bg-info',
        Pickup: 'status-bg-pickup',
        Delivery: 'status-bg-primary',
        Failed: 'status-bg-failed',
        Exception: 'status-bg-exception',
        UnDelivered: 'status-bg-failed'
      }
      return map[status] || 'status-bg-muted'
    },

    getStatusTextColor (status) {
      const map = {
        all: 'status-text-default',
        Transit: 'status-text-transit',
        Pickup: 'status-text-pickup',
        Delivered: 'status-text-delivered',
        UnDelivered: 'status-text-undelivered',
        Exception: 'status-text-exception',
        NotFound: 'status-text-notfound'
      }
      return map[status] || 'text-gray-500'
    },
    getStatusDisplay (status, shipment) {
      const label = (STATUS_LABELS[this.currentLang] && STATUS_LABELS[this.currentLang][status]) || status || STATUS_LABELS[this.currentLang].NotFound
      return shipment && shipment.SignDay ? `${label} (${shipment.SignDay}${this.t('signDaySuffix')})` : label
    },
    getReportStatus (shipment) {
      return this.getStatusDisplay(
        shipment && shipment.LatestLogisticsStatus,
        shipment
      )
    },

    formatShipmentText (shipment) {
      if (!shipment) return ''
      const number = this.getShipmentDisplayNumber(shipment)
      const lines = [
        `${this.t('exportTrackingNumber')}： ${number}`,
        `${this.t('exportPackageStatus')}： ${this.getReportStatus(shipment)}`,
        'XYY:'
      ]
      this.getTrackingLogs(shipment).forEach(evt => {
        const time = this.formatTime(evt.TriggerTime)
        const text = evt.StatusString || ''
        if (time && text) lines.push(`${time} ${text}`)
      })
      return lines.join('\n')
    },

    formatShipmentsText (shipments) {
      const blocks = (shipments || []).map(shipment => this.formatShipmentText(shipment))
        .filter(Boolean)
      if (!blocks.length) return ''
      return `${blocks.join('\n======================================\n')}\nPowered by www.xingyunyi.com`
    },

    async copyText (text, successMessage) {
      if (!text || this.copying) return false
      this.copying = true
      this.copyMessage = ''
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          try {
            await navigator.clipboard.writeText(text)
          } catch (error) {
            this.copyWithFallback(text)
          }
        } else {
          this.copyWithFallback(text)
        }
        this.copyMessage = successMessage || this.t('copied')
        Message.success(this.copyMessage)
        return true
      } catch (error) {
        this.copyMessage = this.t('copyFailed')
        Message.error(this.copyMessage)
        return false
      } finally {
        this.copying = false
      }
    },

    copyWithFallback (text) {
      const textarea = document.createElement('textarea')
      textarea.value = text
      textarea.setAttribute('readonly', '')
      textarea.style.position = 'fixed'
      textarea.style.opacity = '0'
      document.body.appendChild(textarea)
      textarea.select()
      try {
        if (!document.execCommand('copy')) throw new Error('copy failed')
      } finally {
        document.body.removeChild(textarea)
      }
    },

    copyShipment (shipment) {
      return this.copyText(this.getShipmentDisplayNumber(shipment))
    },

    isDesktopDevice () {
      if (typeof window === 'undefined') {
        return false
      }
      if (window.matchMedia) {
        const supportsDesktopPointer = window.matchMedia('(any-hover: hover) and (any-pointer: fine)').matches
        if (supportsDesktopPointer) {
          return true
        }
      }
      const userAgent = typeof navigator !== 'undefined' ? navigator.userAgent || '' : ''
      return !/Android|iPhone|iPad|iPod|Mobile|Windows Phone/i.test(userAgent)
    },

    handleFooterSupportClick (support, event) {
      if (!support || support.action !== 'copyPhoneOnDesktop' || !this.isDesktopDevice()) {
        return
      }
      event.preventDefault()
      const phone = support.value || (support.href || '').replace(/^tel:/, '')
      if (!phone) {
        return
      }
      return this.copyText(phone, this.t('copiedPhone', { phone }))
    },

    copyAllShipments () {
      return this.copyText(this.formatShipmentsText(this.shipments))
    },

    copyAllTrackingNumbers () {
      const numbers = [...new Set(
        this.trackingRows
          .map(row => this.getShipmentNumber(row))
          .filter(Boolean)
      )]
      return this.copyText(numbers.join('\n'))
    },
    getTrackingLogs (shipment) {
      if (!shipment || !Array.isArray(shipment.TrackingLogs)) {
        return []
      }
      return shipment.TrackingLogs
        .map((evt, index) => ({ evt, index, timestamp: new Date(evt.TriggerTime).getTime() }))
        .sort((a, b) => {
          if (Number.isNaN(a.timestamp) && Number.isNaN(b.timestamp)) return a.index - b.index
          if (Number.isNaN(a.timestamp)) return 1
          if (Number.isNaN(b.timestamp)) return -1
          return b.timestamp - a.timestamp || a.index - b.index
        })
        .map(item => item.evt)
    },
    getLatestTrackingText (shipment) {
      if (
        !shipment ||
        !shipment.TrackingLogs ||
        shipment.TrackingLogs.length === 0
      ) {
        return this.t('noTrackingInfo')
      }
      const sorted = this.getTrackingLogs(shipment)
      return sorted.length ? sorted[0].StatusString || '' : this.t('noTrackingInfo')
    },

    formatTime (timeStr) {
      if (!timeStr) return ''
      const date = new Date(timeStr)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    formatSyncTime () {
      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      const hours = String(now.getHours()).padStart(2, '0')
      const minutes = String(now.getMinutes()).padStart(2, '0')
      const seconds = String(now.getSeconds()).padStart(2, '0')
      const offset = -now.getTimezoneOffset() / 60
      const offsetStr =
        offset >= 0 ? `+${String(offset).padStart(2, '0')}` : `${offset}`
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds} (GMT${offsetStr}:00)`
    }

  }
}
</script>

<style>
.tracking-page {
  display: flex;
  height: 100vh;
  flex-direction: column;
  overflow: hidden;
  background-color: #ffffff;
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  color: #111827;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.page-container {
  width: 100%;
  max-width: 1680px;
  margin: 0 auto;
  padding: 0 16px;
  box-sizing: border-box;
}

.text-primary {
  color: #165dff;
}

.text-gray-700 {
  color: #374151;
}

.text-gray-500 {
  color: #6b7280;
}

.announce-bar {
  position: relative;
  background-color: #edf0fe;
}

.announce-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 36px;
  padding: 8px 48px;
  box-sizing: border-box;
  font-size: 13px;
  line-height: 1.25;
}

.announce-text {
  color: #374151;
}

.announce-icon {
  flex-shrink: 0;
}

.announce-link {
  text-decoration: none;
}

.announce-link:hover {
  text-decoration: underline;
}

.announce-close {
  position: absolute;
  top: 50%;
  right: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  background: transparent;
  color: #6b7280;
  transform: translateY(-50%);
  cursor: pointer;
}

.announce-close:hover {
  color: #1f2937;
}

.tracking-header {
  border-bottom: 1px solid #e5e7eb;
  background-color: #ffffff;
}

.tracking-header__inner {
  display: flex;
  height: 64px;
  align-items: center;
  gap: 32px;
}

.tracking-logo-link {
  flex-shrink: 0;
  font-size: 24px;
  font-style: italic;
  font-weight: 900;
  letter-spacing: -0.02em;
  text-decoration: none;
}

.tracking-header__actions {
  display: flex;
  margin-left: auto;
  align-items: center;
  gap: 16px;
}

.mobile-search-button {
  display: none;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: #ff8a00;
  color: #fff;
  box-shadow: 0 4px 10px rgba(255, 138, 0, 0.28);
  cursor: pointer;
}

.mobile-search-button:hover {
  background: #f27d00;
}

.language-switcher {
  position: relative;
  display: none;
}

.language-switcher__trigger {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 0;
  border: 0;
  background: transparent;
  font-size: 14px;
  line-height: 1.25;
  color: #374151;
  cursor: pointer;
}

.language-switcher__trigger:hover {
  color: #165dff;
}

.language-switcher__arrow {
  color: #6b7280;
}

.language-switcher__menu {
  position: absolute;
  top: 100%;
  right: 0;
  z-index: 20;
  min-width: 120px;
  margin-top: 8px;
  overflow: hidden;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  background-color: #ffffff;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

.language-switcher__option {
  display: block;
  width: 100%;
  padding: 8px 16px;
  border: 0;
  background: transparent;
  text-align: left;
  font-size: 14px;
  line-height: 1.25;
  cursor: pointer;
}

.language-switcher__option:hover {
  background-color: #f9fafb;
}

.tracking-tabs-bar {
  border-bottom: 1px solid #e5e7eb;
  background-color: #ffffff;
}

.tracking-tabs-bar__inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.tracking-tabs {
  display: flex;
  align-items: center;
  gap: 4px;
  overflow-x: auto;
  padding: 8px 0;
}

.tab-item {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border: 0;
  border-radius: 4px;
  background: transparent;
  font-size: 13px;
  line-height: 1.25;
  font-weight: 600;
  cursor: pointer;
}

.tab-item:hover {
  background-color: #f3f4f6;
}

.tab-item--active {
  background-color: #f3f4f6;
  color: #111827;
  font-weight: 500;
}

.tab-item--inactive {
  color: #4b5563;
}

.tab-item__count {
  padding-left: 4px;
  color: #9ca3af;
}

.tracking-tabs-actions {
  display: none;
  flex-shrink: 0;
  align-items: center;
  gap: 6px;
}

.icon-action-button,
.sidebar-action-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  background-color: #ffffff;
  color: #6b7280;
  cursor: pointer;
}

.icon-action-button:hover {
  background-color: #f9fafb;
}
.sidebar-action-button:hover {
  background-color: #73737b;
}

.icon-action-button:disabled,
.sidebar-action-button:disabled,
.query-button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.expand-toggle-icons {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
}

.expand-toggle-icon {
  position: absolute;
  left: 50%;
  top: 50%;
  line-height: 1;
}

.expand-toggle-icon--collapsed {
  font-size: 12px;
}

.expand-toggle-icon--collapsed:not(.expand-toggle-icon--mirror) {
  transform: translate(-50%, calc(-50% + 5px)) rotate(360deg);
}

.expand-toggle-icon--mirror {
  /* transform: translate(-50%, calc(-50% - 1px)); */
  transform: translate(-50%, calc(-50% - 3px)) rotate(180deg);
}

.expand-toggle-icon--expanded {
  transform: translate(-50%, -50%) rotate(180deg);
}

.tracking-main {
  display: flex;
  min-height: 0;
  flex: 1;
  flex-direction: column;
  padding-top: 16px;
  padding-bottom: 96px;
}

.tracking-layout {
  display: flex;
  min-height: 0;
  flex: 1;
  flex-direction: column;
  gap: 16px;
}

.tracking-content-panel {
  min-width: 0;
  min-height: 0;
  flex: 1;
  overflow-y: auto;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background-color: #ffffff;
  padding: 16px;
  box-sizing: border-box;
  scroll-behavior: smooth;
  /* overscroll-behavior: contain; */
}

.tracking-state {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 0;
}

.tracking-state__content {
  text-align: center;
}

.tracking-state__icon {
  margin-bottom: 16px;
  font-size: 36px;
}

.shipment-card {
  margin-bottom: 16px;
  padding: 16px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-sizing: border-box;
}

.shipment-card:last-child {
  margin-bottom: 0;
}

.shipment-card--active {
  box-shadow: inset 0 0 0 2px #165dff;
}

.shipment-card__summary {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 40px;
  cursor: pointer;
}

.shipment-card__status {
  display: flex;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
}

.shipment-card__main {
  min-width: 0;
  flex: 1 1 auto;
}

.shipment-card__number-row {
  display: flex;
  align-items: center;
  gap: 6px;
}

.shipment-card__number {
  font-size: 14px;
  line-height: 1.25;
  font-weight: 600;
  color: #111827;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.shipment-card__copy,
.tracking-input-row__remove,
.shipment-card__toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
}

.shipment-card__copy,
.tracking-input-row__remove {
  color: #9ca3af;
}

.shipment-card__copy:hover,
.tracking-input-row__remove:hover,
.shipment-card__toggle:hover {
  color: #4b5563;
}

.shipment-card__status-row {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  line-height: 1.25;
}

.shipment-card__route {
  display: none;
  flex: 0 0 120px;
  width: 120px;
  min-width: 120px;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin: 0;
  align-self: center;
}

.route-brief__point {
  text-align: center;
  font-size: 16px;
  line-height: 1.25;
  color: #374151;
}

.route-brief__country,
.route-brief__arrow {
  color: #9ca3af;
}

.shipment-card__aside {
  display: flex;
  margin-left: auto;
  align-items: flex-start;
  gap: 12px;
}

.shipment-card__latest {
  display: none;
  width: 520px;
  text-align: left;
}

.latest-info__time {
  margin: 0;
  font-size: 13px;
  line-height: 1.25;
  font-weight: 600;
  color: #111827;
}

.latest-info__text {
  margin: 2px 0 0;
  overflow: hidden;
  font-size: 12px;
  line-height: 1.25;
  color: #6b7280;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.shipment-card__toggle {
  margin-top: 4px;
  color: #9ca3af;
}

.shipment-card__toggle-icon {
  font-size: 24px;
  line-height: 1;
}
.shipment-card__toggle-icon_no {
  width: 20px;
}

.shipment-detail {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #f3f4f6;
}

.timeline {
  position: relative;
}

.timeline__list {
  position: relative;
  margin: 0;
  padding: 0;
  list-style: none;
}

.timeline__line {
  position: absolute;
  top: 6px;
  bottom: 6px;
  left: 7px;
  z-index: 0;
  border-left: 1px dashed #d1d5db;
}

.timeline__item {
  position: relative;
  padding-left: 24px;
  padding-bottom: 12px;
}

.timeline__item:last-child {
  padding-bottom: 0;
}

.timeline__dot {
  position: absolute;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
}

.timeline__dot--active {
  top: 3px;
  left: 2px;
  width: 12px;
  height: 12px;
  border-radius: 9999px;
}

.timeline__dot--inactive {
  top: 5px;
  left: 4px;
  width: 8px;
  height: 8px;
  border: 2px solid #d1d5db;
  border-radius: 9999px;
  background-color: #ffffff;
}

.timeline__content {
  display: flex;
  gap: 12px;
  font-size: 13px;
  line-height: 20px;
}

.timeline__time {
  width: 136px;
  flex-shrink: 0;
}

.timeline__time--active,
.timeline__text--active {
  font-weight: 600;
  color: #111827;
}

.timeline__time--inactive {
  color: #9ca3af;
}

.timeline__text--inactive {
  color: #6b7280;
}

.tracking-sidebar {
  width: 100%;
  flex-shrink: 0;
  border-radius: 8px;
}

.tracking-drawer-overlay {
  display: none;
}

.tracking-sidebar__panel {
  border: 1px solid #d1d5db;
  border-radius: 2px;
  background-color: #ffffff;
}

.tracking-input-list {
  max-height: 380px;
  overflow-y: auto;
}

.tracking-input-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 6px 12px;
  box-sizing: border-box;
  border-bottom: 1px solid #f3f4f6;
}

.tracking-input-row:last-child {
  border-bottom: 0;
}

.tracking-input-row__index {
  width: 20px;
  flex-shrink: 0;
  text-align: right;
  font-size: 12px;
  line-height: 1.25;
  color: #9ca3af;
}

.tracking-input-row__field {
  min-width: 0;
  flex: 1;
  padding: 0;
  border: 0;
  background: transparent;
  font-size: 13px !important;
  line-height: 1.25;
  font-weight: 600;
  color: #1f2937;
  text-overflow: ellipsis;
  outline: none;
  border-radius: 1px;
}

.tracking-input-row__field:focus {
  color: #165dff;
}

.tracking-sidebar__toolbar {
  display: flex;
  /* justify-content: space-between; */
  justify-content: end;
  gap: 8px;
  padding: 4px 12px 0;
}

.sidebar-action-button {
  width: auto;
  height: auto;
  padding: 4px 8px;
  font-size: 14px;
  line-height: 1.25;
  font-weight: 500;
  color: #ffffff;
  background-color: #52525B;
}

.tracking-sidebar__submit {
  display: flex;
  gap: 8px;
  padding: 8px 12px 12px;
}

.query-button {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 12px;
  border: 0;
  border-radius: 4px;
  background-color: #ff9500;
  font-size: 14px;
  line-height: 1.25;
  font-weight: 500;
  color: #ffffff;
  cursor: pointer;
}

.query-button:hover {
  background-color: #f08700;
}

.tracking-footer-placeholder {
  bottom: 0;
  left: 0;
  z-index: 40;
  display: flex;
  width: 100%;
  margin: 10px auto 0;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #ffffff 24%, #ffffff 100%);
}

.tracking-footer-card {
  position: relative;
  display: block;
  width: 100%;
  max-width: 1120px;
  margin: 0 auto;
  overflow: hidden;
  border: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 8px;
  text-decoration: none;
}

.tracking-footer-layout {
  position: relative;
  display: flex;
  gap: 10px;
  min-height: 182px;
  height: auto;
  padding: 10px;
  align-items: stretch;
}

.tracking-footer-hero,
.tracking-footer-support {
  position: relative;
  min-width: 0;
  z-index: 1;
}

.tracking-footer-hero {
  display: flex;
  flex: 1.45 1 0;
  flex-direction: column;
  padding: 8px 8px 8px 10px;
}

.tracking-footer-hero--media {
  display: flex;
  align-self: stretch;
  padding: 0;
  overflow: hidden;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: inset 0 0 0 1px rgba(15, 23, 42, 0.05);
}

.tracking-footer-media {
  display: block;
  position: relative;
  flex: 1 1 auto;
  height: 100%;
  min-height: 100%;
  overflow: hidden;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
  text-decoration: none;
}

.tracking-footer-image {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center center;
}

.tracking-footer-image--zh {
  width: 790px;
  max-width: none;
  object-fit: cover;
}

.tracking-footer-brand {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.tracking-footer-brand__mark {
  display: inline-flex;
  width: 48px;
  height: 48px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: 1px solid rgba(15, 23, 42, 0.08);
  background:
    radial-gradient(circle at 30% 30%, rgba(255, 255, 255, 0.95), rgba(233, 240, 255, 0.92) 72%),
    #ffffff;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.7);
  font-size: 20px;
  line-height: 1;
  font-weight: 800;
  letter-spacing: 0.02em;
  color: #111827;
}

.tracking-footer-brand__copy {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 4px;
}

.tracking-footer-brand__name {
  font-size: 28px;
  line-height: 1;
  font-weight: 800;
  color: #111827;
}

.tracking-footer-brand__tagline {
  font-size: 13px;
  line-height: 1.3;
  color: #64748b;
}

.tracking-footer-feature-list {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.tracking-footer-feature {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  min-width: 0;
}

.tracking-footer-feature__icon {
  display: inline-flex;
  width: 34px;
  height: 34px;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: rgba(22, 93, 255, 0.08);
  color: #2563eb;
  flex-shrink: 0;
}

.tracking-footer-feature__icon svg,
.tracking-footer-support-card__icon svg {
  width: 20px;
  height: 20px;
  stroke: currentColor;
  stroke-width: 1.8;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.tracking-footer-feature__copy {
  min-width: 0;
}

.tracking-footer-feature__title {
  display: block;
  margin-bottom: 4px;
  font-size: 12px;
  line-height: 1.2;
  font-weight: 700;
  color: #2563eb;
}

.tracking-footer-feature__text {
  margin: 0;
  font-size: 11px;
  line-height: 1.4;
  color: #64748b;
}

.tracking-footer-hero__body {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 220px;
  gap: 12px;
  align-items: end;
}

.tracking-footer-copy {
  max-width: 480px;
  padding-bottom: 4px;
}

.tracking-footer-copy__title {
  margin: 0;
  font-size: 24px;
  line-height: 1.12;
  font-weight: 800;
  letter-spacing: -0.03em;
  color: #1e3a8a;
}

.tracking-footer-copy__subtitle {
  margin: 12px 0 0;
  font-size: 16px;
  line-height: 1.4;
  font-weight: 700;
  color: #2563eb;
}

.tracking-footer-visual {
  position: relative;
  height: 112px;
}

.tracking-footer-visual__screen {
  position: absolute;
  right: 30px;
  bottom: 4px;
  width: 132px;
  height: 82px;
  border-radius: 12px;
  border: 1px solid rgba(22, 93, 255, 0.12);
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(233, 242, 255, 0.95));
  box-shadow:
    0 12px 30px rgba(37, 99, 235, 0.16),
    inset 0 1px 0 rgba(255, 255, 255, 0.8);
  transform: perspective(320px) rotateY(-14deg);
}

.tracking-footer-visual__screen::before {
  content: "";
  position: absolute;
  left: 10px;
  right: 10px;
  bottom: -10px;
  height: 10px;
  border-radius: 0 0 14px 14px;
  background: linear-gradient(180deg, rgba(22, 93, 255, 0.26), rgba(22, 93, 255, 0.08));
}

.tracking-footer-visual__bar,
.tracking-footer-visual__card,
.tracking-footer-visual__line {
  position: absolute;
  left: 14px;
  right: 14px;
  border-radius: 999px;
}

.tracking-footer-visual__bar {
  top: 12px;
  height: 8px;
  background: rgba(22, 93, 255, 0.16);
}

.tracking-footer-visual__card {
  left: 14px;
  width: 48px;
  border-radius: 10px;
}

.tracking-footer-visual__card--primary {
  top: 28px;
  height: 30px;
  background: linear-gradient(135deg, #165dff, #6aa4ff);
}

.tracking-footer-visual__card--secondary {
  left: 68px;
  top: 28px;
  height: 20px;
  background: rgba(22, 93, 255, 0.14);
}

.tracking-footer-visual__line--short {
  top: 66px;
  height: 6px;
  width: 54px;
  background: rgba(22, 93, 255, 0.14);
}

.tracking-footer-visual__line--long {
  top: 66px;
  left: 76px;
  height: 6px;
  background: rgba(22, 93, 255, 0.26);
}

.tracking-footer-visual__globe {
  position: absolute;
  right: 0;
  bottom: -2px;
  width: 96px;
  height: 96px;
  border-radius: 50%;
  background:
    radial-gradient(circle at 32% 32%, rgba(255, 255, 255, 0.96), rgba(255, 255, 255, 0.2) 34%, transparent 35%),
    radial-gradient(circle at 50% 50%, #4f93ff 0%, #2563eb 56%, #1947bf 100%);
  box-shadow:
    inset -12px -18px 28px rgba(14, 58, 160, 0.3),
    0 18px 32px rgba(37, 99, 235, 0.16);
}

.tracking-footer-visual__globe::before,
.tracking-footer-visual__globe::after {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 50%;
}

.tracking-footer-visual__globe::before {
  background:
    linear-gradient(90deg, transparent 12%, rgba(255, 255, 255, 0.45) 13%, transparent 16%, transparent 48%, rgba(255, 255, 255, 0.38) 49%, transparent 52%, transparent 82%, rgba(255, 255, 255, 0.28) 83%, transparent 86%),
    linear-gradient(180deg, transparent 20%, rgba(255, 255, 255, 0.38) 21%, transparent 24%, transparent 44%, rgba(255, 255, 255, 0.34) 45%, transparent 48%, transparent 68%, rgba(255, 255, 255, 0.24) 69%, transparent 72%);
  opacity: 0.7;
}

.tracking-footer-visual__globe::after {
  inset: 10px;
  border: 1px solid rgba(255, 255, 255, 0.26);
}

.tracking-footer-support {
  display: flex;
  align-self: stretch;
  /* flex: 0.66 1 340px; */
  flex-direction: column;
  justify-content: space-between;
  gap: 10px;
  height: 100%;
  padding: 12px 14px;
  border: 1px solid rgba(15, 23, 42, 0.05);
  border-radius: 8px;
  background: radial-gradient(circle at 76% 74%, rgba(22, 93, 255, 0.12), transparent 38%),
    linear-gradient(120deg, rgba(22, 93, 255, 0.06), rgba(255, 255, 255, 0));
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.7);
}

.tracking-footer-support--zh {
  flex-basis: 476px;
}

.tracking-footer-support__header {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.tracking-footer-support__title {
  margin: 0;
  font-size: 20px;
  line-height: 1;
  font-weight: 600;
  color: #111827;
}

.tracking-footer-support__subtitle {
  margin: 0;
  font-size: 12px;
  line-height: 1.3;
  color: #64748b;
}

.tracking-footer-support__grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
}

.tracking-footer-support-card {
  display: flex;
  min-height: 88px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px;
  border: 1.5px solid rgba(37, 99, 235, 0.08);
  border-radius: 12px;
  background: linear-gradient(180deg, #ffffff, #f8fbff);
  cursor: pointer;
  text-decoration: none;
}

.tracking-footer-support-card__icon {
  display: inline-flex;
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  /* background: rgba(22, 93, 255, 0.08); */
  color: #2563eb;
  font-weight: bold;
}

.tracking-footer-support-card__icon .iconfont {
  font-size: 28px;
  line-height: 1;
}

.tracking-footer-support-card__title {
  text-align: center;
  font-size: 14px;
  line-height: 1.35;
  font-weight: 700;
  color: #5D5675;
}

.tracking-footer-support-card__arrow {
  font-size: 18px;
  line-height: 1;
  font-weight: 700;
  color: #2563eb;
}

.text-gray-900 {
  color: #111827;
}

.status-bg-success {
  background-color: #28a745;
}

.status-bg-primary {
  background-color: #165dff;
}
.status-bg-pickup {
  background-color: #0d47a1;
}

.status-bg-info {
  background-color: #0aa57a;
}

.status-bg-failed {
  background-color: #e64545;
}

.status-bg-exception {
  background-color: #ff7d00;
}

.status-bg-muted {
  background-color: #6b7280;
}

.status-text-default {
  color: #111827;
}

.status-text-transit {
  color: #2196f3;
}

.status-text-pickup {
  color: #0d47a1;
}

.status-text-delivered {
  color: #43a047;
}

.status-text-undelivered {
  color: #f44336;
}

.status-text-exception {
  color: #ff6f00;
}

.status-text-notfound {
  color: #757575;
}

.visible-icon .iconfont {
  font-size: 22px;
  color: #ffffff;
}

@media (min-width: 640px) {
  .tracking-tabs-actions {
    display: flex;
  }

  .shipment-card__latest {
    display: block;
  }
}

@media (min-width: 768px) {
  .language-switcher {
    display: block;
  }

  .shipment-card__route {
    display: flex;
  }
}

@media (min-width: 1024px) {
  .page-container {
    padding: 0 24px;
  }

  .tracking-main {
    padding-top: 16px;
  }

  .tracking-layout {
    flex-direction: row;
  }

  .tracking-sidebar {
    width: 320px;
  }

  .tracking-footer-placeholder {
    max-width: 1630px;
    justify-content: center;
  }

  .tracking-footer-card {
    width: auto;
    max-width: none;
    margin: 0;
  }

  .tracking-footer-layout {
    display: flex;
  }

  .latest-info__text {
    max-width: 520px;
  }
}
@media (min-width: 1600px) {
  .tracking-footer-placeholder {
    max-width: 1630px;
    justify-content: flex-start;
  }
  .tracking-footer-card {
    width: calc(100% - 358px);
    max-width: none;
    margin: 0;
  }
}
@media (min-width: 1670px) {
  .tracking-footer-card {
    width: calc(100% - 336px);
    max-width: none;
    margin: 0;
  }
}

/* Tailwind preflight equivalents and local interaction polish */
.tracking-page,
.tracking-page *,
.tracking-page *::before,
.tracking-page *::after {
  box-sizing: border-box;
}

.tracking-page button,
.tracking-page input {
  font: inherit;
}

.tracking-page button:focus-visible,
.tracking-page input:focus-visible,
.tracking-page a:focus-visible {
  outline: 2px solid #165dff;
  outline-offset: 2px;
}

/* .tracking-page img {
  display: block;
  max-width: 100%;
} */
.tracking-footer-media img {
  display: block;
  width: 784px;
  object-fit: cover;
}

.tracking-logo-link {
  transition: opacity 0.15s ease;
}

.tracking-logo-link:hover {
  opacity: 0.85;
}

.tracking-content-panel {
  /* scrollbar-color: #d1d5db transparent;
  scrollbar-width: thin;
  scrollbar-gutter: stable; */
}

.tracking-content-panel::-webkit-scrollbar {
  width: 6px;
}

.tracking-input-list::-webkit-scrollbar {
  width: 6px;
}

.tracking-content-panel::-webkit-scrollbar-track,
.tracking-input-list::-webkit-scrollbar-track {
  background: transparent;
}

.tracking-content-panel::-webkit-scrollbar-button,
.tracking-input-list::-webkit-scrollbar-button {
  display: none;
  width: 0;
  height: 0;
}

.tracking-content-panel::-webkit-scrollbar-thumb,
.tracking-input-list::-webkit-scrollbar-thumb {
  border-radius: 9999px;
  background-color: #d1d5db;
}

.tracking-content-panel::-webkit-scrollbar-thumb:hover,
.tracking-input-list::-webkit-scrollbar-thumb:hover {
  background-color: #9ca3af;
}

.shipment-card {
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.shipment-card:hover {
  border-color: #cbd5e1;
}

.shipment-card--active,
.shipment-card--active:hover {
  border-color: #93b4ff;
  box-shadow: inset 0 0 0 2px #165dff, 0 1px 2px rgba(15, 23, 42, 0.04);
}

.shipment-card__status {
  overflow: hidden;
}

.shipment-card__copy:disabled,
.tracking-input-row__remove:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.tracking-input-row__field::placeholder {
  color: #9ca3af;
  font-weight: 400;
  opacity: 1;
}

.tracking-input-row:focus-within {
  background-color: #f8fafc;
}

.query-button {
  min-height: 36px;
  transition: background-color 0.15s ease, box-shadow 0.15s ease;
}

.query-button:hover:not(:disabled) {
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.12);
}

.tracking-sidebar__panel {
  overflow: hidden;
}

@media (max-width: 639px) {
  .announce-content {
    min-height: 40px;
    padding-right: 44px;
    padding-left: 44px;
    text-align: center;
  }

  .tracking-header__inner {
    height: 56px;
  }

  .tracking-logo-link img {
    width: 150px;
    height: auto;
  }

  .tracking-main {
    padding-top: 12px;
    padding-bottom: 92px;
  }

  .tracking-footer-card {
    border-radius: 18px 18px 0 0;
  }

  .tracking-footer-layout {
    flex-direction: column;
    height: auto;
    gap: 6px;
    padding: 6px;
  }

  .tracking-footer-layout::before {
    width: 100%;
    inset: 0;
  }

  .tracking-footer-hero,
  .tracking-footer-support {
    padding: 8px;
  }

  .tracking-footer-hero--media {
    padding: 0;
  }

  .tracking-footer-brand__mark {
    width: 40px;
    height: 40px;
    font-size: 17px;
  }

  .tracking-footer-brand__name {
    font-size: 22px;
  }

  .tracking-footer-brand__tagline {
    font-size: 12px;
  }

  .tracking-footer-feature-list,
  .tracking-footer-support__grid {
    grid-template-columns: 1fr;
  }

  .tracking-footer-hero__body {
    grid-template-columns: 1fr;
  }

  .tracking-footer-copy {
    max-width: none;
  }

  .tracking-footer-copy__title {
    font-size: 20px;
  }

  .tracking-footer-copy__subtitle {
    margin-top: 10px;
    font-size: 14px;
  }

  .tracking-footer-visual {
    height: 96px;
  }

  .tracking-footer-visual__screen {
    right: 42px;
    width: 118px;
    height: 74px;
  }

  .tracking-footer-visual__globe {
    width: 84px;
    height: 84px;
  }

  .tracking-footer-support {
    display: none;
    gap: 8px;
    padding: 8px;
  }

  .tracking-footer-support__title {
    font-size: 16px;
  }

  .tracking-footer-support__subtitle {
    overflow: hidden;
    font-size: 11px;
    line-height: 1.25;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .tracking-footer-support__grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 5px;
  }

  .tracking-footer-support-card {
    min-height: 58px;
    gap: 3px;
    padding: 6px 3px;
    border-radius: 6px;
    cursor: pointer;
  }

  .tracking-footer-support-card__icon {
    width: 24px;
    height: 24px;
  }

  .tracking-footer-support-card__icon .iconfont {
    font-size: 18px;
  }

  .tracking-footer-support-card__title {
    overflow: hidden;
    width: 100%;
    font-size: 10px;
    line-height: 1.2;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .tracking-footer-support-card__arrow {
    display: none;
  }

  .tracking-content-panel {
    padding: 12px;
  }

  .shipment-card {
    padding: 12px;
  }

  .shipment-card__summary {
    gap: 12px;
    min-height: 36px;
  }

  .shipment-card__status {
    width: 36px;
    height: 36px;
  }

  .shipment-card__number {
    overflow-wrap: anywhere;
  }

  .timeline__content {
    flex-direction: column;
    gap: 2px;
    line-height: 18px;
  }

  .timeline__time {
    width: auto;
  }
}

@media (min-width: 1280px) {
  .tracking-content-panel {
    padding: 20px;
  }

  .shipment-card {
    padding: 18px;
  }
}

@media (max-width: 639px) {
  .tracking-page {
    height: 100dvh;
    min-height: 0;
    overflow: hidden;
  }

  .page-container {
    padding-right: 12px;
    padding-left: 12px;
  }

  .tracking-header__inner {
    gap: 12px;
  }

  .mobile-search-button {
    display: inline-flex;
  }

  .language-switcher {
    display: block;
  }

  .language-switcher__trigger {
    min-height: 36px;
    padding: 6px 0 6px 6px;
    font-size: 13px;
  }

  .language-switcher__menu {
    min-width: 104px;
    margin-top: 4px;
  }

  .language-switcher__option {
    min-height: 36px;
    padding: 9px 12px;
    font-size: 13px;
  }

  .tracking-tabs-bar__inner {
    align-items: flex-start;
    padding-right: 8px;
    padding-left: 8px;
  }

  .tracking-tabs-actions {
    display: flex;
    flex-shrink: 0;
    gap: 4px;
    padding-top: 6px;
  }

  .tracking-tabs-actions .icon-action-button {
    width: 30px;
    height: 30px;
  }

  .tracking-tabs {
    display: flex;
    flex: 1;
    width: auto;
    min-width: 0;
    flex-wrap: wrap;
    gap: 4px;
    overflow: visible;
    padding-top: 6px;
    padding-bottom: 6px;
  }

  .tab-item {
    flex: 0 1 auto;
    min-width: 0;
    max-width: 100%;
    justify-content: center;
    padding: 4px 8px;
    font-size: 12px;
    text-align: center;
  }
  .tab-item span {
    font-size: 12px;
  }

  .tab-item > span:last-child {
    min-width: 0;
    overflow-wrap: anywhere;
    word-break: break-word;
  }

  .tab-item__count {
    padding-left: 2px;
  }

  .tracking-main {
    position: relative;
    min-height: 0;
    flex: 1;
    padding-top: 10px;
    padding-bottom: 12px;
    overflow: hidden;
  }

  .tracking-drawer-overlay {
    position: fixed;
    inset: 0;
    z-index: 80;
    display: block;
    background: rgba(15, 23, 42, 0.32);
  }

  .tracking-layout {
    min-height: 0;
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .tracking-sidebar {
    position: fixed;
    top: 62px;
    right: 12px;
    left: auto;
    z-index: 90;
    display: none;
    width: min(84vw, 390px);
    margin: 0;
    border-radius: 12px;
    transform: translateY(-12px) scale(0.98);
    transform-origin: top right;
    transition: opacity 0.2s ease, transform 0.2s ease;
  }

  .tracking-sidebar--drawer-open {
    display: block;
    transform: translateY(0) scale(1);
  }

  .tracking-sidebar__panel {
    max-height: min(72vh, 520px);
    overflow-y: auto;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    box-shadow: 0 12px 30px rgba(15, 23, 42, 0.2);
  }

  .tracking-content-panel {
    min-height: 0;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 8px;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
  }

  .tracking-input-list {
    max-height: 34vh;
  }

  .tracking-input-row {
    min-height: 38px;
    padding: 7px 10px;
  }

  .tracking-input-row__field {
    min-width: 0;
    font-size: 14px !important;
  }

  .tracking-sidebar__toolbar {
    padding-right: 10px;
    padding-left: 10px;
  }

  .tracking-sidebar__submit {
    padding-right: 10px;
    padding-bottom: 10px;
    padding-left: 10px;
  }

  .shipment-card {
    margin-bottom: 10px;
    padding: 10px;
  }

  .shipment-card__summary {
    align-items: flex-start;
    gap: 8px;
  }

  .shipment-card__status {
    width: 32px;
    height: 32px;
  }

  .visible-icon .iconfont {
    font-size: 18px;
  }

  .shipment-card__main {
    flex: 1;
    padding-top: 1px;
  }

  .shipment-card__number-row,
  .shipment-card__status-row {
    min-width: 0;
  }

  .shipment-card__number {
    min-width: 0;
    overflow-wrap: anywhere;
    word-break: break-word;
    font-size: 13px;
  }

  .shipment-card__status-row {
    overflow-wrap: anywhere;
    word-break: break-word;
    font-size: 12px;
    line-height: 1.4;
  }

  .shipment-card__aside {
    gap: 4px;
    margin-left: 0;
    padding-top: 1px;
  }

  .shipment-card__toggle {
    flex-shrink: 0;
    margin-top: 0;
    min-width: 24px;
    min-height: 28px;
  }

  .shipment-card__toggle-icon {
    font-size: 20px;
  }

  .shipment-detail {
    margin-top: 12px;
    padding-top: 12px;
  }

  .timeline__item {
    padding-left: 20px;
    padding-bottom: 10px;
  }

  .timeline__content {
    min-width: 0;
  }

  .timeline__text {
    overflow-wrap: anywhere;
    word-break: break-word;
  }

  .tracking-footer-placeholder {
    margin-top: 0;
    padding: 0 8px;
  }

  .tracking-footer-card {
    border-radius: 12px 12px 0 0;
  }

  .tracking-footer-layout {
    min-height: 0;
    padding: 6px;
  }

  .tracking-footer-hero--media {
    display: block;
    flex: 0 0 auto;
    width: 100%;
    height: auto;
    min-height: 0;
  }

  .tracking-footer-media {
    display: block;
    width: 100%;
    height: auto;
    min-height: 0;
  }

  .tracking-footer-media img,
  .tracking-footer-image,
  .tracking-footer-image--zh {
    display: block;
    width: 100%;
    max-width: 100%;
    height: auto;
    min-height: 1px;
    object-fit: contain;
  }

  .tracking-footer-support--zh {
    flex-basis: auto;
  }
}

@font-face {
  font-family: "iconfont"; /* Project id 5220011 */
  src: url('//at.alicdn.com/t/c/font_5220011_dywh6hlzx8c.woff2?t=1786607385957') format('woff2'),
       url('//at.alicdn.com/t/c/font_5220011_dywh6hlzx8c.woff?t=1786607385957') format('woff'),
       url('//at.alicdn.com/t/c/font_5220011_dywh6hlzx8c.ttf?t=1786607385957') format('truetype');
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-xiaoxi:before {
  content: "\e600";
}

.icon-kefu:before {
  content: "\e7e1";
}

.icon-email:before {
  content: "\e60c";
}

.icon-shangjiantou:before {
  content: "\e62a";
}

.icon-zhedie:before {
  content: "\e616";
}

.icon-parcel-02-search:before {
  content: "\ea39";
}

.icon-package-delivered:before {
  content: "\e649";
}

.icon-all:before {
  content: "\e602";
}

.icon-delete:before {
  content: "\e625";
}

.icon-up-and-down-arrow:before {
  content: "\e736";
}

.icon-search:before {
  content: "\e65a";
}

.icon-copy-document:before {
  content: "\ed4e";
}

.icon-single-arrow:before {
  content: "\e66b";
}

.icon-delivered2:before {
  content: "\e6e1";
}

.icon-status_notfound:before {
  content: "\e648";
}

.icon-pick-up-16:before {
  content: "\e742";
}

.icon-Undelivered:before {
  content: "\e601";
}

.icon-yichang:before {
  content: "\e618";
}

.icon-plane-departure-solid:before {
  content: "\e72e";
}

.scrollbar-hide::-webkit-scrollbar {
  display: none;
}

.scrollbar-hide {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.shipment-detail-enter-active,
.shipment-detail-leave-active {
  overflow: hidden;
  transition: max-height 0.3s ease, opacity 0.25s ease, transform 0.3s ease;
}

.shipment-detail-enter,
.shipment-detail-leave-to {
  max-height: 0;
  opacity: 0;
  transform: translateY(-8px);
}

.shipment-detail-enter-to,
.shipment-detail-leave {
  max-height: 1200px;
  opacity: 1;
  transform: translateY(0);
}

.bg-success {
  background-color: #28a745;
}

.text-success {
  color: #28a745;
}

.bg-primary {
  background-color: #165dff;
}

.text-primary {
  color: #165dff;
}

.visible-icon .iconfont {
  font-size: 22px;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/tracking2.vue